module.exports = __webpack_public_path__ + "static/img/home_tanque.8a68aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_tanque.png
// module id = 87
// module chunks = 0